import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  InputLabel,
  Grid2,
  ListItemIcon,
  ListItemText,
  InputAdornment,
  Menu,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { Card, CardContent, Box } from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Modal from "@mui/material/Modal";
import "../assets/css/Datatable.css";
import "../assets/css/TodayRecord.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import { MdCancel } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { styled, alpha } from "@mui/material/styles";

import { Toolbar } from "primereact/toolbar";
import { InputSwitch } from "primereact/inputswitch";
import FilterListIcon from "@mui/icons-material/FilterList";
import SwapVertSharpIcon from "@mui/icons-material/SwapVertSharp";
import RenderCurationTransposedTable from "./RenderCurationTransposedTable";
import { IoIosClose } from "react-icons/io";
import { grey } from "@mui/material/colors";

const TodayRecords = ({ refresh }) => {
  const [records, setRecords] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editableFields, setEditableFields] = useState({});
  const [statusType, setStatusType] = useState("dataFile"); // Default is Data File Status
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [editedData, setEditedData] = useState({});
  const [openBulkEdit, setOpenBulkEdit] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [isSortClicked, setIsSortClicked] = useState(false);
  const [bulkeditdata, setbulkeditdata] = useState({
    arrival_time: "",
    data_arrived: "",
  });
  const [duplicateselect,setDuplicateselect]=useState(false)
  const [editingRowData, setEditingRowData] = useState([]);

  const handleOpen = () => setOpenBulkEdit(true);
  const handleClose = () => setOpenBulkEdit(false);
  const [areFiltersEnabled, setAreFiltersEnabled] = useState(false);
  const [editElement, setEditElement] = useState([]);
  const [bulkEditFields, setBulkEditFields] = useState({
    name: "",
    email: "",
  });
  const [username,setUsername]=useState(null);
  const [filters, setFilters] = useState(null);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1); // 1 for ascending, -1 for descending

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});

  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsSortClicked(!isSortClicked)
  };

 
  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
    const storedData = localStorage.getItem('username');
    console.log(storedData,"nnnnnnnnnnnnnn");
    setUsername(storedData);
    
    
    
  }, []); // Empty dependency array to only run on component mount

  const handleSelectClose = (columneName) => {
    console.log(columneName, "colummm");
    sortDataBy(columneName);
    setIsSortClicked(!isSortClicked)
    setAnchorEl(null);
  };

  const onSortButtonClick = () => {
    setSortField("source_table");
    setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sorting order
  };
  const handleEdit = (e) => {
    if (selectedRecord && selectedRecord.length > 0) {
      console.log(e, "evalue");

      console.log(selectedRecord[0], "000000000000000");
      setEditElement(selectedRecord[0]);
      console.log(selectedRecord, "selected user");
      console.log(editElement, "eeeeeeeeeeee user");
    } else {
      console.log("No user selected");
    }

    setOpenEdit(!openEdit);
  };

  const handleBulkEdit = () => {
    setOpenBulkEdit(!openBulkEdit);
  };
  // useEffect(()=>{
  //   setbulkeditdata({data_arrived:'NOT ARRIVED',arrival_time:null});
  //   setEditableFields({data_arrived:editElement.data_arrived,arrival_time:editElement.arrival_time});
  // },[selectedRecord])
  // Fetch records based on the status type
  const fetchRecords = async () => {
    try {
      const apiUrl =
        refresh === 0
          ? "/get-source-details-today/"
          : "/get-curation-details-today/";

      const response = await axios.get(apiUrl);

      console.log(response, "responce", refresh, "tab");
     
      const sortedRecords= refresh !==0 ?(response?.data?.sort(
        (a, b) => new Date(b.id) - new Date(a.id)
      )):(response.data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      ))

      setRecords(sortedRecords);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, [refresh, statusType]);
  const style = {
    maxWidth: "25rem",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,

    bgcolor: "background.paper",

    boxShadow: 24,
    p: 0,
    borderRadius: "12px",
  };

  const handleEditClick = (index) => {
    console.log("helooooooooooooooooo");

    setEditIndex(index);
    console.log("after", index, editIndex);

    setEditableFields({
      ...records[index],
    });
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setEditableFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color: "rgb(55, 65, 81)",
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[300],
      }),
    },
  }));

  const handleSaveClick = async (id) => {
    console.log(editingRowData, "Updated editing row data");
    try {
        // Determine the API endpoint based on the refresh state
        const apiUrl =
            refresh === 0
                ? `/update-source-details/${id}/`
                : `/update-curation-details/${id}/`;

        const updatedFields = {
            ...editElement,
            ...editableFields,
            duplicate_count: editingRowData[0]?.duplicate_count||editElement?.duplicate_count,
            validated_by:username
        };
        const headers = {
          "Content-Type": "application/json",
          "X-CSRFToken": cookies.csrftoken,
        };
        await axios.put(apiUrl, updatedFields,{headers});
        console.log(editElement, "editElement", updatedFields);
        setEditElement((prev) => ({
            ...prev,
            ...updatedFields,
        }));
        setSelectedRecord((prevRecords) =>
            prevRecords.map((record) =>
                record.id === id ? { ...record, ...updatedFields } : record
            )
        );
        setRecords((prev) => {
            return prev.map((record) =>
                record.id === id ? { ...record, ...updatedFields } : record
            );
        });
        setEditableFields({});
        setEditIndex(null);
        setOpenEdit(!openEdit);
        setSelectedRecord([]);
        setEditingRowData([])
        setDuplicateselect(false);
      
    } catch (error) {
        console.error("Error updating record:", error);
    }
};

  const handleInputChange = (fieldKey, value) => {
    setEditableFields((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
    console.log(editableFields, "editable fields");
  };

  const handleArrivedChange = (value) => {
    setEditableFields((prev) => ({
      ...prev,
      no_of_files: {
        ...prev.no_of_files,
        Arrived: value, // Only update the Arrived key
      },
    }));
  };

  const handleCancelClick = () => {
    setEditIndex(null);
  };

  
  const handleBulk = async () => {
    // await handleSaveDuplicateCount(); // Ensure individual edits are saved first

    const formattedArrivalTime = bulkeditdata?.arrival_time;
    console.log(formattedArrivalTime,"format")
    console.log(editingRowData,":::::::::::")
    
    const updatedRecords = selectedRecord.map((record) => {
        const existingEdit = editingRowData.find((edit) => edit.id === record.id);
        console.log(existingEdit,"editedit");

        // Ensure duplicate_count is always a valid number
        const updatedDuplicateCount = existingEdit && existingEdit.duplicate_count !== undefined && existingEdit.duplicate_count !== ''
            ? Number(existingEdit?.duplicate_count) 
            : Number(record?.duplicate_count); 
            // const formatArrivalDate =(record?.arrival_date ) || ""; // Use empty string if formatting fails
            // const formatCreatedAt = (record?.created_at) || ""; // Use empty string if formatting fails
            // console.log(formatArrivalDate,existingEdit?.arrival_date ,formatCreatedAt,existingEdit?.created_at,"format")
        return {
            ...record,
            // arrival_date: existingEdit ? (existingEdit?.arrival_date): formatArrivalDate,
            // created_at: existingEdit ?(existingEdit?.created_at ): formatCreatedAt,
            arrival_time: formattedArrivalTime || null,
            data_arrived: bulkeditdata?.data_arrived || "NOT ARRIVED",
            duplicate_count: updatedDuplicateCount ,
            validated_by:username
        };
    });

    console.log(updatedRecords, "Updated records to be sent in bulk edit");
    const headers = {
      "Content-Type": "application/json",
      "X-CSRFToken": cookies.csrftoken,
    };
    try {
        const response = await axios.put(
            "update-bulk-source-details/",
            updatedRecords,{headers}
        );

        console.log(response, "Response from bulk update");

        // Merge with the updated records
        setRecords((prevRecords) =>
            prevRecords.map((record) => {
                const updatedRecord = updatedRecords.find((r) => r.id === record.id);
                return updatedRecord ? { ...record, ...updatedRecord } : record;
            })
        );
        
        // Reset form state
        setbulkeditdata({ arrival_time: null, data_arrived: "NOT ARRIVED" });
        setEditIndex(null);
        fetchRecords();
        setSelectedRecord([]);
        setDuplicateselect(false);
        setOpenBulkEdit(!openBulkEdit);
    } catch (error) {
        console.error("Error updating records:", error);
    }

    // Reset selected records and close modal
    setSelectedRecord([]);
    setBulkEditFields({ name: "", email: "" });
    handleClose();
};


   
  const toggleFilters = () => {
    setAreFiltersEnabled(!areFiltersEnabled);
    setIsFilterClicked(!isFilterClicked);
    filterState();
  };
  const onGlobalFilterChange = (e) => {
    setSearchValue(e.target.value);
    const value = e.target.value;
    let _filters = { ...filters };
    console.log(_filters, "........ffffffffff");
    _filters["global"].value = value;
    setFilters(_filters);
  };
  const sortDataBy = (clmName) => {
    const sortedData = [...records].sort((a, b) => {
      const valueA = a[clmName];
      const valueB = b[clmName];
  
      // Handle undefined or null values
      const valA = valueA !== undefined && valueA !== null ? valueA : "";
      const valB = valueB !== undefined && valueB !== null ? valueB : "";
  
      if (typeof valA === "number" && typeof valB === "number") {
        // Numeric comparison
        return (valA - valB) * sortOrder;
      } else {
        // String comparison (convert to lowercase for case-insensitive comparison)
        const nameA = valA.toString().toLowerCase();
        const nameB = valB.toString().toLowerCase();
  
        if (nameA < nameB) return sortOrder;
        if (nameA > nameB) return -sortOrder;
        return 0;
      }
    });
  
    setRecords(sortedData); // Update the state with sorted data
    setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sortOrder for the next click
  };
  const sortDataBySourceName = (clmName) => {
    const sortedData = [...records].sort((a, b) => {
      const nameA = a.source_name.toLowerCase() || "";
      const nameB = b.source_name.toLowerCase() || "";

      if (nameA < nameB) return sortOrder; // Ascending or descending based on sortOrder
      if (nameA > nameB) return -sortOrder;
      return 0;
    });

    setRecords(sortedData); // Update the state with sorted data
    setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sortOrder for the next click
  };

  const dataTableHeader = (
    <div
      className="table-header align-items-center  py-3"
      style={{ display: "flex" }}
    >
      <span
        className="p-input-icon-left"
        style={{ justifyContent: "flex-start" }}
      >
        {!searchValue && <FaSearch className="p-icon" />}
        <InputText
          className="input py-1"
          type="search"
          onInput={onGlobalFilterChange}
          placeholder="Search"
          // InputProps={{
          //   endAdornment: (
          //     <InputAdornment position="end">
          //       <IconButton  edge="end" >
          //       <FaSearch />
          //       </IconButton>
          //     </InputAdornment>
          //   ),
          // }}
          has
          context
          menu
        />
      </span>

      <div
        style={{
          marginLeft: "auto",
          display: "flex",
          alignItems: "center",
          background: "white",
        }}
      >
        <Button
          variant="text"
          className="btn-sm ms-1 py-1"
          style={{
            color: isFilterClicked?"#fff":"#333333",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
            background:isFilterClicked?"#0576FC":"",
          }}
          onClick={toggleFilters}
          startIcon={
            <FilterListIcon sx={{ color: isFilterClicked?"#fff":"#0576FC", fontSize: "1.2rem" }} />
          }
        >
          Filter
        </Button>
        <Button
          id="demo-customized-button"
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          variant="text"
          className="btn-sm ms-1 py-1"
          style={{
            color: "#0576FC",
            fontSize: "15px",
            fontWeight: 500,
            marginRight: "10px",
            background:isSortClicked?"#0576FC":"",
            color:isSortClicked?"#fff":"#333333",
          }}
          aria-expanded={open ? "true" : undefined}
          disableElevation
          onClick={handleClick}
          startIcon={<SwapVertSharpIcon sx={{ color:  isSortClicked?"#fff":"#0576FC"  }} />}
        >
          Sort
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleSelectClose}
        >
          <MenuItem
            onClick={() => handleSelectClose("source_name")}
            disableRipple
          >
            Source Name
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("source_table")}
            disableRipple
          >
            Source Table
          </MenuItem>

          <MenuItem
            onClick={() => handleSelectClose("frequency")}
            disableRipple
          >
            Frequency
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("expected_time")}
            disableRipple
          >
            Expected Time
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("last_arrival_datetime")}
            disableRipple
          >
            Last Arrival Date
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("duplicate_count")}
            disableRipple
          >
            Duplicate Count
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("arrival_date")}
            disableRipple
          >
            Arrival Date
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("arrival_time")}
            disableRipple
          >
            Arrival Time
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("data_arrived")}
            disableRipple
          >
            Arrival Status
          </MenuItem>
          <MenuItem
            onClick={() => handleSelectClose("validated_by")}
            disableRipple
          >
            Validated By
          </MenuItem>
        </StyledMenu>
      </div>
    </div>
  );
  const getFrequencyStyle = (value) => {
    switch (value) {
        case 'DAILY':
            return {background:"#007bff20", color: '#007bff', padding: '0.2rem 1.5rem', borderRadius: '25px' }; 
        case 'WEEKLY':
            return { backgroundColor: '#28a74520', color: '#28a745', padding: '0.2rem 1.3rem', borderRadius: '25px' }; 
        case 'MONTHLY':
          return { backgroundColor: '#dffa7c63', color: '#dab326', padding: '0.2rem 0.5rem', borderRadius: '25px' };
        case 'QUARTERLY':
            return { backgroundColor: '#fde5cd', color: '#f08a2c', padding: '0.2rem 0.5rem', borderRadius: '25px' }; 
        default:
            return { backgroundColor: '#e4dbee', color: '#7339bb', padding: '0.2rem 1.1rem', borderRadius: '25px'}; 
    }
};
  const filterState=()=>{
    setFilters({
      source_name: { value: null, matchMode: "contains" },
      source_table: { value: null, matchMode: "contains" },
      frequency: { value: null, matchMode: "contains" },
      expected_time: { value: null, matchMode: "contains" },
      last_arrival_datetime:{value:null,matchMode:"contains"},
      duplicate_count:{value:null,matchMode:"contains"},
      arrival_date: { value: null, matchMode: "contains" },
      arrival_time: { value: null, matchMode: "contains" },
      data_arrived: { value: null, matchMode: "contains" },
      validated_by: { value: null, matchMode: "contains" },
      global: { value: null, matchMode: "contains" },
    });
  }
  useEffect(() => {
   filterState();
  }, []);
  const onRowEditComplete = (e) => {
    let _products = [...records];
    let { newData, index } = e;

    _products[index] = newData;

    setRecords(_products);
  };
  const allowEdit = (rowData) => {
    return rowData.name !== "Blue Band";
  };

  const statusBodyTemplate = (rowData) => {
    const style = getFrequencyStyle(rowData.frequency);
    return <span style={style}>{rowData.frequency}</span>;
};
  const CustomHeaderCheckbox = ({
    selectedRecord,
    onSelectionChange,
    records,
  }) => {
    const isAllSelected =
      records.length > 0 && selectedRecord.length === records.length;

    const toggleAll = () => {
      if (isAllSelected) {
        onSelectionChange([]);
      } else {
        onSelectionChange(records);
      }
    };

  
 

    return (
      <label style={{ display: "inline-block", cursor: "pointer" }}>
        <input
          type="checkbox"
          checked={isAllSelected}
          onChange={toggleAll}
          aria-label="Select All"
          style={{ display: "none" }} // Hide the default checkbox
        />
        <span
          style={{
            display: "inline-block",
            width: "20px", // Adjust to match other checkboxes
            height: "20px", // Adjust to match other checkboxes
            // border: "none", // Remove the border to match the others
            // backgroundColor: isAllSelected ? "#624ad2" : "white", // Use the same purple shade
            borderRadius: "5px", // Adjust the border-radius if needed
            transition: "background-color 0.2s ease",
          }}
        >
          {/* Add a checkmark if selected */}
          {isAllSelected ? (
            // <svg
            //   xmlns="http://www.w3.org/2000/svg"
            //   viewBox="0 0 24 24"
            //   fill="white"
            //   width="24px"
            //   height="26px"
            //   style={{ display: "block", margin: "auto",fontWeight:300 }}
            // >
            //   <path d="M0 0h24v24H0z" fill="none" />
            //   <path d="M9 16.2l-3.5-3.5L4 14l5 5 9-9-1.5-1.5z" />
            // </svg>
            <CheckBoxIcon sx={{ color: "#0576Ff", fontSize: "1.65rem" }} />
          ) : (
            <CheckBoxOutlineBlankIcon
              sx={{ color: "#c3c8cd", fontSize: "1.65rem" }}
            />
          )}
        </span>
      </label>
    );
  };

 
 
  const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return ""; 
  
    const [day, month, year] = dateString.split('-');
    
    // Check if day, month, and year exist and are valid
    if (!day || !month || !year) return "";
  
    // Return formatted date in YYYY-MM-DD
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }
  const formatDateTimeToYYYYMMDD = (dateTimeString) => {
    if (!dateTimeString) return ""; 
  
    const [datePart, timePart] = dateTimeString.split(' '); 
  
    // Ensure the datePart exists and is in the correct format
    if (!datePart || !timePart) return "";
  
    const [day, month, year] = datePart.split('-');
  
    // Check if day, month, and year exist
    if (!day || !month || !year) return "";
  
    // Return formatted date with time
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${timePart}`;
  };
  
  
  
  const handleNoDuplicateChange = (e, rowData) => {
    setDuplicateselect(true);
    
    const updatedDuplicateCount = e.target.value;

    
    // const formattedArrivalDate = (rowData?.arrival_date) || ""; 
    // const formattedCreatedAt =(rowData?.created_at) || ""; 

    
    const existingRowIndex = editingRowData.findIndex((row) => row.id === rowData.id);

    let updatedEditingRowData = [...editingRowData];

    if (existingRowIndex >= 0) {

        updatedEditingRowData[existingRowIndex] = {
            ...updatedEditingRowData[existingRowIndex],
            duplicate_count: updatedDuplicateCount,
            // arrival_date: formattedArrivalDate, 
            // created_at: formattedCreatedAt,
            validated_by:username,
        };
    } else {
        
        updatedEditingRowData.push({
            ...rowData,
            duplicate_count: updatedDuplicateCount,
            // arrival_date: formattedArrivalDate, 
            // created_at: formattedCreatedAt,    
            validated_by:username,
        });
    }

    // Update the state with the modified array
    setEditingRowData(updatedEditingRowData);

    console.log(updatedEditingRowData, "Updated editing row data");
};

  
  
  const handleSaveDuplicateCount=async()=>{
    console.log(editingRowData,"uuuuuuuuuu")
    console.log('fhg',cookies.csrftoken);
    
    const headers = {
      "Content-Type": "application/json",
      "X-CSRFToken": cookies.csrftoken,
    };
    try {
      const response = await axios.put(
        "update-bulk-source-details/",
        editingRowData,{headers}
      );

      console.log(response, "resssssssssss");
      
      setRecords((prevRecords) =>
        prevRecords.map((record) => {
          const updatedRecord = editingRowData.find((r) => r.id === record.id);
          return updatedRecord ? { ...record, ...updatedRecord } : record;
        })
      );
      setEditingRowData([]);
      setSelectedRecord([]);
      setDuplicateselect(false)
    } catch (error) {
      console.error("Error updating record:", error);
    }

  }

  
  // const NoDuplicateEditor = (rowData) => {
  //   return (
  //     <InputText
  //     style={{
  //       width:"100px"
  //     }}
  //     min={"0"}
  //       type="number"
  //       defaultValue={rowData?.duplicate_count}
  //       onChange={(e) => handleNoDuplicateChange(e, rowData)}
  //     />
  //   );
  // };
  const renderDataFileTable = () => {
    return (
      <div>
       
        <DataTable
          value={records}
          editable
          sortable
          paginator
          rows={10}
          resizableColumns
          header={dataTableHeader}
          filters={filters}
          filterDisplay="row"
          selection={selectedRecord}
          onSelectionChange={(e) => setSelectedRecord(e.value)}
          dataKey="id"
          selectionMode="checkbox"
          editMode="row"
          sortField={sortField}
          sortOrder={sortOrder}
          onRowEditComplete={onRowEditComplete}
          paginatorLeft={`Total Records: ${records.length}`}
          className={
            areFiltersEnabled
              ? "p-datatable-striped filters-enabled custom-data-table px-4 bg-white"
              : "p-datatable-striped filters-disabled custom-data-table px-4 bg-white"
          }
          style={{
            paddingBottom:"20px",
            borderRadius:"12px",
          }}
          globalFilterFields={[
            "source_name",
            "source_table",
            "frequency",
            'last_arrival_datetime',
            "expected_time",
            "arrival_date",
            "arrival_time",
            "data_arrived",
            "duplicate_count",
            "validated_by",
          ]}
          emptyMessage={
            <div
              style={{
                textAlign: "center",
                width: "100%",
                height: "1.5rem",
                marginTop: "0.5rem",
              }}
            >
              No Records Available
            </div>
          }
        >
          <Column
            selectionMode={records?.length > 0 && "multiple"}
            header={
              <CustomHeaderCheckbox
                selectedRecord={selectedRecord}
                onSelectionChange={setSelectedRecord}
                records={records}
              />
            }
          />

          <Column
            field="source_name"
            header="Source Name"
            filter
            filterMenuStyle={{ textAlign: "center" }}
            filterPlaceholder="Search by source name"
          />
          <Column
            field="source_table"
            header="Source Table"
            filter
            style={{
              maxWidth: "100px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            body={(rowData) => (
              <span
                style={{
                  cursor: "pointer",
                }}
              >
                <Tooltip title={rowData.source_table}>
                  {rowData.source_table}
                </Tooltip>
              </span>
            )}
            filterMenuStyle={{ textAlign: "center" }}
            filterPlaceholder="Search by Source Table"
          />
          <Column
            field="frequency"
            header="Frequency"
            filter
            style={{textTransform:"uppercase"}}
            body={statusBodyTemplate}
            filterMenuStyle={{ textAlign: "center" }}
            filterPlaceholder="Search by frequency"
             headerClassName="custom-header-padding"
             headerStyle={{paddingLeft:"20px",textTransform:"none"}}
          />
          <Column
            field="expected_time"
            header="Expected By"
            filter
            style={{
              // maxWidth: "100px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            body={(rowData) => (
              <span
                style={{
                  cursor: "pointer",
                }}
              >
                <Tooltip title={rowData.expected_time}>
                  {rowData.expected_time}
                </Tooltip>
              </span>
            )}
            filterMenuStyle={{ textAlign: "center" }}
            filterPlaceholder="Search by Expected By"
          />
           <Column
                field="last_arrival_datetime"
                header="Last Arrival Date"
                // body={(rowData) => {
                //     const value = rowData.last_arrival_datetime;
                //     return isValidDate(value) ? formatDate(value) : value; // Format only if it's a valid date
                // }}
                filter
                filterMenuStyle={{ textAlign: "center" }}
                filterPlaceholder="Search by last Arrival Date"
            />
         <Column
  field="duplicate_count"
  header="Duplicate Count"
  filter
  filterPlaceholder="Search by Duplicate Count"
  body={(rowData) => {
    // Check if the current row is selected
    const isSelected = selectedRecord.some(record => record.id === rowData.id);
    
    return (
      <span
        style={{
          color: rowData.duplicate_count == 0 ? "black" : "red",
          cursor: isSelected ? "text" : "pointer", // Change cursor to indicate editability
        }}
      >
        {isSelected ? (
          <InputText
            style={{
              width: "100px"
            }}
            min={"0"}
            type="number"
            defaultValue={rowData?.duplicate_count}
            onChange={(e) => handleNoDuplicateChange(e, rowData)}
            onKeyDown={(e) => {
              
              if (
                e.key === 'e' ||
                e.key === 'E' ||
                e.key === '+' ||
                e.key === '-' ||
                e.key === '.'
              ) {
                e.preventDefault();
              }
            }}
          />
        ) : (rowData.duplicate_count == 0 ? '-':rowData.duplicate_count
        )}
      </span>
    );
  }}
  // headerStyle={{paddingLeft:"30px"}}
  style={{ textAlign: 'center' }}
/>


         <Column
  field="arrival_date"
  header="Arrival Date"
  filter
  filterMenuStyle={{ textAlign: "center" }}
  filterPlaceholder="Search by Arrival Date"
  // body={(rowData) => {
  //   const arrivalDate = new Date(rowData.arrival_date);
  //   const day = String(arrivalDate.getDate()).padStart(2, '0'); // Get day and ensure 2 digits
  //   const month = String(arrivalDate.getMonth() + 1).padStart(2, '0'); // Get month and ensure 2 digits
  //   const year = arrivalDate.getFullYear(); // Get year
  //   return `${day}-${month}-${year}`; // Return formatted date as dd-mm-yyyy
  // }}
  headerStyle={{ textAlign: "center" }}
  style={{ textAlign: 'center' }}
/>

          <Column
            field="arrival_time"
            header="Arrival Time"
            filter
            filterMenuStyle={{ textAlign: "center" }}
            filterPlaceholder="Search by Arrival Time"
            body={(rowData) =>
              rowData.arrival_time ? rowData?.arrival_time : " "
            }
          />
          <Column
            field="data_arrived"
            header="Arrival Status"
            body={(rowData) =>
              <span
              style={{
                color: rowData.data_arrived === "ARRIVED LATE" ? "red" : "",
              }}
            >
              {rowData?.data_arrived}
            </span>
            }
            filter
            filterMenuStyle={{ minWidth: "12rem", textAlign: "center" }}
            filterPlaceholder="Search by Arrival Status"
          />
          <Column
            field="validated_by"
            header="Validated By"
            filter
            body={(rowData) => rowData.validated_by}
            filterMenuStyle={{ minWidth: "8rem", textAlign: "center" }}
            filterPlaceholder="Search by validated By"
          />
          {/* <Column
         
          body={(rowData, { rowIndex }) => (
            <>
           
              {editIndex === rowIndex ? (
                <>
                  <Button  style={{marginRight:"10px"}} onClick={() => handleSaveClick(rowData.id,rowIndex)} >
                    <i className='pi pi-check'></i>
                  </Button>
                  <Button onClick={handleCancelClick} >
                  <i className='pi pi-times'></i>
                  </Button>
                </>
              ) : (
                <Button  onClick={() => handleEditClick(rowIndex)} ><i className='pi pi-pencil'></i></Button>
              )}
            </>
          )}
        /> */}
        </DataTable>
      </div>
    );
  };

  const statuses = [
    { label: "NOT ARRIVED", value: "NOT ARRIVED" },
    { label: "ARRIVED EARLY", value: "ARRIVED EARLY" },
    { label: "ARRIVED ON TIME", value: "ARRIVED ON TIME" },
    { label: "ARRIVED LATE", value: "ARRIVED LATE" },
  ];

  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    { field: "category", header: "Category" },
    { field: "quantity", header: "Quantity" },
  ];
  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const file=selectedRecord?.length===0?records:selectedRecord;
      const worksheet = xlsx.utils.json_to_sheet(file);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Todays");
    });
  };
  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(data, fileName + "Record" + EXCEL_EXTENSION);
      }
    });
  };
  return (
    <div style={{ position: "relative", padding: "0px" }}>
      {refresh === 0 && renderDataFileTable()}
      {refresh === 1 && (
        <RenderCurationTransposedTable
          setRecords={setRecords}
          records={records}
          editableFields={editableFields}
          setEditableFields={setEditableFields}
          fetchRecords={fetchRecords}
        />
      )}
      <Box
        className="selected-users"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "sticky",
          // marginTop:"24rem",
          bottom: "2rem",
          // marginBottom: "5%",
          // marginX: "30%",
        }}
      >
         {records && records.length > 0 && refresh===0 && (
        
          <>
           <div className="action-bar">
          {selectedRecord && selectedRecord.length > 0 && (
             <div className="selection-summary">
             {selectedRecord && selectedRecord.length}
             <span className="light-text" style={{ padding: "2px" }}>
               {" "}
               of{" "}
             </span>
             {records && records.length}
             <span className="light-text"> selected</span>
           </div>
          )}
           
             

              <button onClick={exportExcel} className="action-button ">
                Export
              </button>

              <button
                className="action-button me-2"
                onClick={(e) => handleEdit(e)}
                disabled={
                  selectedRecord &&
                  (selectedRecord.length > 1 || selectedRecord.length === 0)
                } // Disables if more than 1 user
              >
                Edit
              </button>

              <button
                className="action-button"
                onClick={handleBulkEdit}
                disabled={
                  selectedRecord &&
                  (selectedRecord.length === 1 || selectedRecord.length === 0)
                } // Disables if exactly 1 user
              >
                Bulk edit{console.log(editElement, "edit fewl")}
              </button>
              {/* {!isEditingEnabled?(
                <button
                className="action-button mx-2"
                onClick={() =>{setIsEditingEnabled(!isEditingEnabled)
                  setSelectedRecord([]);
                 }}
              >
                Edit Duplicate Count
              </button>):( */}
              {duplicateselect?
                <button
                className="action-button me-2"
                onClick={() =>{
                  handleSaveDuplicateCount();
                  setIsEditingEnabled(!isEditingEnabled)}}
              >
                Save Duplicate Count
              </button>:("")

                }
            </div>

            {/* <Card>
              <CardContent
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "5px",
                  background: "black",
                  color: "white",
                  height: "1.8rem",
                }}
              >
                <Button style={{ color: "white" }}>
                  {selectedRecord
             && selectedRecord
            .length} of{" "}
                  {records && records.length} selected
                </Button>

                <Button
                  style={{ color: "white" }}
                  onClick={exportExcel}
                  data-pr-tooltip="XLS"
                >
                  Export
                </Button>
                {selectedRecord
           && selectedRecord
          .length === 1 ? (
                  <Button
                    style={{ color: "white" }}
                    onClick={(e) => handleEdit(e)}
                  >
                    Edit
                  </Button>
                ) : (
                  <Button style={{ color: "white" }} onClick={handleBulkEdit}>
                    Bulk Edit
                  </Button>
                )}
              </CardContent>
            </Card> */}
          </>
        )}
        <Modal
          open={openBulkEdit}
          onClose={handleBulkEdit}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                sx={{ color: "#333", padding: "30px 40px 0px 40px" }}
                component="h2"
              >
                Apply Bulk Edit
              </Typography>
            </div>
            <div style={{ padding: "0px 32px 32px 32px" }}>
              <Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "400", mt: 3 }}
              >
                Arrival Time
              </Typography>
              <TextField
                size="small"
                name="arrival_time"
                type="time"
                onChange={(e) =>
                  setbulkeditdata({
                    ...bulkeditdata,
                    arrival_time: e.target.value,
                  })
                }
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "400", mt: 3 }}
              >
                Arrival Status
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  labelId="data-arrived-label"
                  name="data_arrived"
                  defaultValue={"NOT ARRIVED"}
                  onChange={(e) =>
                    setbulkeditdata({
                      ...bulkeditdata,
                      data_arrived: e.target.value,
                    })
                  }
                >
                  <MenuItem value="NOT ARRIVED">NOT ARRIVED</MenuItem>
                  <MenuItem value="ARRIVED EARLY">ARRIVED EARLY</MenuItem>
                  <MenuItem value="ARRIVED ON TIME">ARRIVED ON TIME</MenuItem>
                  <MenuItem value="ARRIVED LATE">ARRIVED LATE</MenuItem>
                </Select>
              </FormControl>
              <div className="save-button">
                <Button
                  variant="contained"
                  className="save-button mx-3"
                  onClick={() => handleBulkEdit()}
                  endIcon={<MdCancel />}
                  sx={{ mt: 3, background: "#fff", color: "grey" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  // className="save-button"
                  onClick={handleBulk}
                  sx={{
                    mt: 3,
                    display: "flex",
                    justifyContent: "center",
                    background: "#0576Ff",
                  }}
                  endIcon={<SaveOutlinedIcon />}
                >
                  Save
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
        {/*working */}
        <Modal
          open={openEdit}
          onClose={handleEdit}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                sx={{ color: "#333", padding: "30px 40px 0px 40px" }}
                component="h2"
              >
                Apply Edit
              </Typography>
            </div>
            <div style={{ padding: "0px 32px 32px 32px" }}>
              {console.log(
                editElement,
                "elem",
                editableFields,
                "fields",
                editedData,
                "data"
              )}
              <Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "400", mt: 3 }}
              >
                Arrival Time
              </Typography>
              <TextField
                size="small"
                name="arrival_time"
                type="time"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                defaultValue={editElement?.arrival_time}
                onChange={(e) =>
                  handleInputChange("arrival_time", e.target.value)
                }
              />
              {console.log(editElement?.data_arrived, "now...")}
              <Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "400", mt: 3 }}
              >
                Arrival Status
              </Typography>
              <FormControl size={"small"} fullWidth>
                <Select
                  labelId="data-arrived-label"
                  name="data_arrived"
                  defaultValue={editElement?.data_arrived}
                  onChange={(e) =>
                    handleInputChange("data_arrived", e.target.value)
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="ARRIVED EARLY">ARRIVED EARLY</MenuItem>
                  <MenuItem value="ARRIVED ON TIME">ARRIVED ON TIME</MenuItem>
                  <MenuItem value="ARRIVED LATE">ARRIVED LATE</MenuItem>
                  <MenuItem value="NOT ARRIVED">NOT ARRIVED</MenuItem>
                </Select>
              </FormControl>
              {/* </Grid> */}

              <div className="save-button">
                <Button
                  variant="contained"
                  className="save-button mx-3"
                  onClick={() => setOpenEdit(!openEdit)}
                  endIcon={<MdCancel />}
                  sx={{ mt: 3, background: "#fff", color: "grey" }}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ mt: 3, background: "#0576Ff" }}
                  variant="contained"
                  onClick={() => handleSaveClick(editElement.id)}
                  endIcon={<SaveOutlinedIcon />}
                >
                  Save
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
        {/* <Modal
          open={openEdit}
          onClose={handleEdit}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Apply Edit
            </Typography>
           
                     <Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "550",mt: 3  }}
              >
                Arrival Time
              </Typography>
                <TextField
                  name="arrival_time"
                  type="time"
                  size="small"
                  fullWidth
                  defaultValue={editElement?.arrival_time}
                  onChange={(e) =>
                    handleInputChange("arrival_time", e.target.value)
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              {console.log(editElement?.data_arrived, "editttttttt")}
              <Typography
                className="mb-1"
                variant="body2"
                sx={{ fontWeight: "550",mt: 3  }}
              >
                Data Arrived
              </Typography>
                <FormControl size={"small"} fullWidth>
                  <Select
                    labelId="data-arrived-label"
                    name="data_arrived"
                    defaultValue={editElement?.data_arrived}
                    onChange={(e) =>
                      handleInputChange("data_arrived", e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                   <MenuItem value="ARRIVED EARLY">ARRIVED EARLY</MenuItem>
                    <MenuItem value="ARRIVED EARLY">ARRIVED EARLY</MenuItem>
                    <MenuItem value="ARRIVED ON TIME">ARRIVED ON TIME</MenuItem>
                    <MenuItem value="ARRIVED LATE">ARRIVED LATE</MenuItem>
                    <MenuItem value="NOT ARRIVED">NOT ARRIVED</MenuItem>
                  </Select>
                </FormControl>

            <div className="save-button">
              <Button
                sx={{ mt: 3,background:"#624ad2" }}
                variant="contained"
                onClick={() => handleSaveClick(editElement.id)}
              >
                Save Changes
              </Button>
            </div>
          </Box>
        </Modal> */}
      </Box>
    </div>
  );
};

export default TodayRecords;